import {Controller} from "@hotwired/stimulus"
import Swiper, {Lazy, Navigation, Keyboard} from "swiper"

export default class extends Controller {
  static targets = [  "carousel" ]
  static values = {
    initialSlideIndex: Number,
    keyboardNavigation: { default: false, type: Boolean },
  }

  connect() {
    this.initCarousel()
  }

  initCarousel() {
    this.swiper = new Swiper(this.carouselTarget, {
      modules: [Lazy, Navigation, Keyboard],
      initialSlide: this.initialSlideIndexValue,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      watchSlidesProgress: true,
      slidesPerView: 1,
      speed: 1,
      lazy: {
        enabled: true,
        loadPrevNext: true
      },
      loop: true,
      preloadImages: false,
      simulateTouch: false,
      keyboard: {
        enabled: this.keyboardNavigationValue,
        onlyInViewport: true,
      }
    })
  }

  goToSlide(slideNumber) {
    this.swiper.slideTo(slideNumber, 0)
  }
}
